export default {
  error: state => state.error,
  categoryError: state => state.categoryError,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  exportLoading: state => state.exportLoading,
  exportSuccess: state => state.exportSuccess,
  preventNew: state => state.preventNew,
  news: state => state.news,
  allnews: state => state.allnews,
  category: state => state.category,
  categoryById: state => state.categoryById,
  paging: state => state.paging,
  downloadLink: state => state.downloadLink,
  accountsWithTotal: state => state.accountsWithTotal,
  newsCreated: state => state.newsCreated,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/News/getters.js